<template>
  <app-select-box
    :label-text="layout.sectionLabel"
    :options="sectionsList"
    :selected="selectedSection.id"
    :on-change-cb="handleSectionChange"
    :has-default-option-null="true"
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "SectionsSelector",
  computed: {
    ...mapGetters({
      sectionsList: "level/getSectionsList",
      selectedSection: "delivery/getSelectedSection",
      layout: "venueSettings/getLayout"
    })
  },
  methods: {
    ...mapActions({
      switchSection: "level/switchSection"
    }),
    ...mapMutations({
      setSelectedSection: "delivery/setSelectedSection"
    }),
    handleSectionChange(event) {
      const selectedSection = event.target.value;
      this.switchSection(selectedSection);
      this.setSelectedSection({ sectionId: selectedSection });
    }
  }
};
</script>
